import urlConfig from "../../url-config.json";
import { parse } from "tldts";

export const getApiUrl = (lang) => {
  return getUrlForCurrentDomain()["api"][lang ?? "en"];
};


export const getBackendHostBaseUrl = (lang) => {
  return getUrlForCurrentDomain()["api"][lang ?? "en"].replace("/api/", "");
};

export const getFrontendUrl = (lang) => {
  return getUrlForCurrentDomain()["frontEnd"][lang ?? "en"];
};

export const getSurveyUrl = (lang) => {
  return getUrlForCurrentDomain()["survey"][lang ?? 'en']
}


export const getUrlForCurrentDomain = () => {
  var hostName = parse(window.location.hostname).domain;
  var found = urlConfig[hostName];
  console.log(`Using domain: ${found ? hostName : ''}`);
  return found ?? Object.values(urlConfig)[0];
};


export const getCurrentDomain = () => {
  var hostName = parse(window.location.hostname).domain;
  var found = urlConfig[hostName];
  return found ? hostName : null;
};
